import { FC } from "react";

const ButtonContainer: FC<{
  visible?: boolean,
  position?: any,
  handleClickAcceptBtn: any,
  handleClickClearBtn: any
}> = ({ visible, handleClickAcceptBtn, handleClickClearBtn }) => {
  return (
    <div className={`btns__block ${visible ? 'btns__block_visible' : 'btns__block_hidden'}`}>
      <button className="accept__btn" onClick={handleClickAcceptBtn}>
        Выбрать
      </button>
      <button className="clear__btn" onClick={handleClickClearBtn}>
        Очистить
      </button>
    </div>
  );
};

export default ButtonContainer;